import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { AuthIllustration } from '../../../../assets/illustration';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { useGetSignedInUser } from '../../../../hooks/useGetSignedInUser';
import { APP_URLS } from '../../../../routes/urls';
import { adminRegisterationSectionStyles } from './styles';

export const AdminRegistrationSection: React.FC = () => {
  const { isSignedIn } = useGetSignedInUser();
  if (isSignedIn) return null;
  return (
    <Box sx={{ py: 5 }} className="container-fluid">
      <Typography variant="h3" component="h2" sx={adminRegisterationSectionStyles.heading}>
        Register your institute and connect with{' '}
        <Typography variant="h3" sx={{ bgcolor: 'warning.light' }} component="span">
          thousands of students
        </Typography>
      </Typography>
      <Grid
        container
        direction={{ xs: 'column-reverse', md: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2.5}
      >
        <Grid item xs={12} md={6} lg={5}>
          <Box sx={adminRegisterationSectionStyles.card}>
            <Typography variant="h6" sx={{ mb: 2.5 }} component="h3">
              Register as academic admin
            </Typography>
            <Typography sx={{ mb: 4 }} paragraph variant="medium" color="secondary">
              <b>Register as an academic admin</b> so that you can manage details of your institution, programs,
              courses, scholarships and many more.
            </Typography>
            <Button variant="contained" color="primary" component={Link} to={APP_URLS.academicAdminRegister}>
              Register now
            </Button>
          </Box>
          <Box sx={[adminRegisterationSectionStyles.card, { mt: 4 }]}>
            <Typography variant="h6" sx={{ mb: 2.5 }} component="h3">
              Register as scholarship provider
            </Typography>
            <Typography sx={{ mb: 4 }} paragraph variant="medium" color="secondary">
              <b>Register as a Scholarship Provider</b> to publish and manage scholarships and criteria.
            </Typography>
            <Button variant="contained" color="primary" component={Link} to={APP_URLS.scholarshipAdminRegister}>
              Register now
            </Button>
          </Box>
        </Grid>
        <Grid item md={5} lg={4}>
          <AppIcon role="presentation" sx={adminRegisterationSectionStyles.illustration} Icon={AuthIllustration} />
        </Grid>
      </Grid>
    </Box>
  );
};
